// extracted by mini-css-extract-plugin
export default {"article-section":"ArticleSection_article-section__OaFCJ","article-section__button":"ArticleSection_article-section__button__hd6rI"};